export default __webpack_public_path__ + "static/media/Arrow 1.377eded2.svg";